import { BrowserBridge } from "./browserBridge";
import { FlutterBridge } from "./flutterBridge";

import type { NativeBridge } from "./bridge";
function isFlutterWebView() {
  return !!window.flutter_inappwebview;
}
export const nativeBridge: NativeBridge = isFlutterWebView() ? new FlutterBridge() : new BrowserBridge();
